<div *ngIf="quotation">
    <!-- START Resume card -->
    <card>
        <div class="card-header-content">
            <h1>{{ wording.searchResume }}</h1>

            <div>
                <btn type="actionDo"
                     (click)="goToSearch()"
                     [value]="wording.backToSearch">
                </btn>
            </div>
        </div>

        <div class="card-body-content card-marge-inside">
            <resume [resume]="quotation" [isUnitSearch]="true"></resume>
        </div>
    </card>
    <!-- END Resume card -->


    <!-- Loader / Notification Part -->
    <card *ngIf="loader.active" mode='bodyOnly'>
        <loader class="card-body-content" [message]="loader.message"></loader>
    </card>
    <card *ngIf="error.active" mode='bodyOnly'>
        <notification class="card-body-content" [type]="error.type">{{error.message}}</notification>
    </card>
    <!-- END Loader / Notification Part -->

    <!-- START Quotation card -->
    <card>
        <div class="card-header-content">
            <h1>{{ wording.accomodation }}</h1>
            <div>
                <terms-of-use-checkbox
                        [hotelQuote]="quotation.quote"
                        [(isTermsOfUseAccepted)]="isTermsOfUseAccepted">
                </terms-of-use-checkbox>
                <btn type="actionDo"
                     [value]="wording.book"
                     [disableIf]="loader.active || isTermsOfUseAccepted === false"
                     (onClick)="book()">
                </btn>
            </div>

        </div>
        <div class="card-body-content">
            <sector-stay-details [booking]="mappedBooking"
                                 [sector]="mappedSector"
                                 [showIcon]="true"
                                 [quote]="quotation.quote"
                                 [quoteProperty]="quotation.property[quotation.quote.property]"></sector-stay-details>
        </div>
    </card>
    <!-- END Quotation card -->

    <!-- START Travellers - Remark - Notes card -->
    <div class="travellers-remark">
        <travellerForm #travellerForm
                       *ngIf="travellersList && ageLimitConfig"
                       class="flex-2 travellers"
                       [nbItems]="(travellersList | keys).length"
                       [travellerItem]="getTravellers()"
                       [disableTypes]="true"
                       [ageLimitConfig]="ageLimitConfig"
                       [useApis]="false"
                       [columns]="true"
                       (onSubmit)="checkTravellersFormValidity($event)"
                       (onGetTravellerInformations)="getTravellerInformations($event)">
        </travellerForm>
        <div class="right-col">
            <emergency-contact *ngIf="canAddEmergencyContact"
                               #emergencyContact
                               [isPhoneRequired]="isPhoneRequired"
                               [existingEmail]="existingEmail"
                               [existingPhoneNumber]="existingPhoneNumber"
                               [configuration]="iaqobohReservationFormParamsConfig?.emergencyContactForm">
            </emergency-contact>
            <!--            <remark class="flex-1 right-col-component"></remark>-->

            <ng-container *ngIf="canAddServices">
                <card class="right-col-component">
                    <div class="card-header-content">
                        <h1>{{(servicesFormConfiguration?.labelArray || wording.specialRequests)  | localized}}</h1>
                    </div>
                    <div class="card-body-content">
                        <check-note [servicesFormConfiguration]="servicesFormConfiguration"
                                    (onCheckedEvent)="checkNoteChange($event)">
                        </check-note>
                    </div>
                </card>
            </ng-container>

            <ng-container *permissionIf="notepadEditorPermission">
                <card *ngIf="travellersList && ageLimitConfig" class="right-col-component">
                    <div class="card-header-content">
                        <h1>{{wording.notes}}</h1>
                    </div>
                    <div class="card-body-content">
                        <notepad #notepadComponent
                                 [displayMode]="'CREATE'"
                                 [isEditPermission]="isNotepadPermission"
                                 [isLengthRestriction]="true"
                                 [notes]="notes">
                        </notepad>
                    </div>
                </card>
            </ng-container>
        </div>

    </div>
    <!-- END Travellers card -->
</div>
